import React from "react";
import PropTypes from "prop-types";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  useMediaQuery,
} from "@mui/material";

const HaqtSingleSelect = (props) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleChange = (event) => {
    // Pass the value to the Formik handleChange function
    props.onChange && props.onChange(event);
  };

  const handleBlur = () => {
    // Call the Formik handleBlur function
    props.onBlur && props.onBlur({ target: { name: props.name } });
  };

  return (
    <FormControl
      sx={{ width: props.width }}
      size={props.size}
      className="haqt-single-select"
      fullWidth
      error={props.error}
    >
      <InputLabel id={props.id}>{props.label}</InputLabel>
      <Select
        name={props.name}
        labelId={props.id}
        id={props.id}
        value={props.value}
        label={props.label}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={props.disabled}
      >
        {props.options?.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
    </FormControl>
  );
};

HaqtSingleSelect.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ).isRequired,
  value: PropTypes.any.isRequired,
  id: PropTypes.any,
  width: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onBlur:PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  error: PropTypes.bool,
  helperText: PropTypes.string
};

export default HaqtSingleSelect;
